import { useEffect } from "react";
import Footerr from "../components/Footerr/Footerr";
import MissionVision from "../components/MissionVission/MissionVision";
import Reception from "../components/Reception/Reception";
import NewCoreValues from "../components/CoreValues/NewCoreValues";
import { Header } from "../components/shared";
import usePageMeta from "../../seo/usePageMeta";

function StoryPage() {
  usePageMeta({
    title: "Our Story | Terces Solutions",
    description:
      "Founded in 2022, Terces Solutions exists to fix fragmented restaurant operations with a holistic, system-driven consulting approach.",
    path: "/Ourstory",
  });

  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <div className="story-page">
      <Header />
      <main className="story-content">
        <Reception />
        <MissionVision />
        <NewCoreValues />
      </main>
      <Footerr />
    </div>
  );
}

export default StoryPage;
